import { Component, EventEmitter, OnDestroy, OnInit, Output, ChangeDetectionStrategy, ChangeDetectorRef, inject, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Subscription } from 'rxjs';
import { GtwSnackbarService } from '../../../shared/_services/gtw-snackbar.service';
import { Form4797Service } from './form4797.service';
import * as _ from 'lodash-es';
import { GlobalService } from '../../../global/services/global.service';
import { WorkspaceService } from '../../../workspace/workspace.service';
import { AppService } from '../../../app.service';
import {
  buildHeaderDataShell,
  generalConfigFromGlobal,
  normalizeFilterParams,
  rowPayloadFromActiveScreen
} from '../../../shared/workspace-element-context';

@Component({
    selector: 'gtw-form4797',
    templateUrl: './form4797.component.html',
    styleUrls: ['./form4797.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class Form4797Component implements OnInit, OnDestroy {
  private readonly destroyRef = inject(DestroyRef);


  @Output('request-grid-update') requestGridUpdate = new EventEmitter<string>();

  private readonly subs = new Subscription();
  private isInitialized = false;

  baseURLs: any = { admin: '', api: '', custom: '', efile: '', pdfEngine: '', bulkPdfEngine: '' };
  globalService: any = {};
  GENERAL_CONFIG: any = {};
  filterParams: any = {};
  rowData: any = {};

  minimise = false;
  crudLoading = false;
  showFormLoader = true;
  modalTitle = 'Form 4797: Sales of Business Property - Increase (Decrease) To Taxable Income';

  activeTab = 0;
  selectedTabName = 'Form Entry';

  formData: any = null;

  /** Entry tab: static form structure */
  FormEntryData = {
    section1: {
      singlerows: ['Total Gain (Loss) per Tax Return', '0'],
      partITitle: 'Part I: Sales or Exchanges of property Used in a Trade or Business and Involuntary Conversions From Other Than Casuality or Theft - Most Property Held More Than 1 Year',
      emptyRows: [] as any[],
      totals: [{ description: 'Total Part I Gain or (Loss)' }]
    },
    section2: {
      partIITitle: 'Part II: Ordinary Gains and Losses',
      emptyRows: [] as any[],
      totals: [{ description: 'Total Part II Gain or (Loss)' }]
    },
    section3: {
      partIIITitle: 'Part III: Gain From Disposition of Property Under Section 1245',
      emptyRows: [] as any[],
      totals: [{ description: 'Total Part III Gain or (Loss)' }]
    }
  };

  line2Headers: any[] = [];
  line10Headers: any[] = [];
  line19Headers: any[] = [];
  Form4797Line2HeaderComment: any = { name: 'Comments' };
  Form4797Line10HeaderComment: any = { name: 'Comments' };
  Form4797Line19HeaderComment: any = { name: 'Comments' };

  formData_2: any = { addrows: [], editrows: [], removerows: [] };
  formData_10: any = { addrows: [], editrows: [], removerows: [] };
  formData_19: any = { addrows: [], editrows: [], removerows: [] };
  formData_2_errorMessages: any = { addrows: [], editrows: [], removerows: [] };
  formData_10_errorMessages: any = { addrows: [], editrows: [], removerows: [] };
  formData_19_errorMessages: any = { addrows: [], editrows: [], removerows: [] };

  form4797Line2Records: any[] = [];
  form4797Line10Records: any[] = [];
  form4797Line19Records: any[] = [];
  form4797Line2RecordsCopy: any[] = [];
  form4797Line10RecordsCopy: any[] = [];
  form4797Line19RecordsCopy: any[] = [];

  displayViewValue_2: boolean[] = [];
  displayEditValue_2: boolean[] = [];
  displayViewValueComment_2: boolean[] = [];
  displayEditValueComment_2: boolean[] = [];
  displayViewValue_10: boolean[] = [];
  displayEditValue_10: boolean[] = [];
  displayViewValueComment_10: boolean[] = [];
  displayEditValueComment_10: boolean[] = [];
  displayViewValue_19: boolean[] = [];
  displayEditValue_19: boolean[] = [];
  displayViewValueComment_19: boolean[] = [];
  displayEditValueComment_19: boolean[] = [];

  line4Details: any[] = [];
  line5Details: any[] = [];
  line14Details: any[] = [];
  line15Details: any[] = [];
  line16Details: any[] = [];
  line4Amt = 0;
  line5Amt = 0;
  line14Amt = 0;
  line15Amt = 0;
  line16Amt = 0;
  line4AmtOrig = 0;
  line5AmtOrig = 0;
  line14AmtOrig = 0;
  line15AmtOrig = 0;
  line16AmtOrig = 0;

  totalLine2Amt = 0;
  totalLine10Amt = 0;
  totalLine19Amt = 0;
  totalPerTaxReturn: any[] = [];
  totalPerDetailsLines: any[] = [];
  totalPerUnallocated: any[] = [];
  totalPerForm4797: any[] = [];
  totalUnallocatedAmt: any[] = [];

  line2FormLineKey = 0;
  line10FormLineKey = 0;
  line19FormLineKey = 0;
  v_form_key = 1;
  recordData_2: any[] = [];
  recordData_10: any[] = [];
  recordData_19: any[] = [];
  formData_line4: any = { editrows: [] };
  formData_line5: any = { editrows: [] };
  formData_line14: any = { editrows: [] };
  formData_line15: any = { editrows: [] };
  formData_line16: any = { editrows: [] };
  temprow2_editdata: any[] = [];
  temprow10_editdata: any[] = [];
  temprow19_editdata: any[] = [];

  /** View tab data */
  viewData: any = {
    partI: { title: '', cols: [] as string[], rows: [] as any[], rows2: [] as any[], totals: [] as any[] },
    partII: { title: '', cols: [] as string[], rows: [] as any[], rows2: [] as any[], totals: [] as any[] },
    partIII: { title: '', cols: [] as string[], rows: [] as any[], rows3: [] as any[], rows4: [] as any[], totals: [] as any[] },
    partIV: { title: '', cols: [] as string[], rows: [] as any[] }
  };

  private defaultWidths = ['4%', '15%', '11%', '11%', '11%', '11%', '11%', '8%', '8%', '10%'];

  constructor(
    private gtwGlobal: GlobalService,
    private gtwWorkspace: WorkspaceService,
    private gtwApp: AppService,
    private cdr: ChangeDetectorRef,
    private gtwSnackbarService: GtwSnackbarService,
    private form4797Service: Form4797Service
  ) {}

  ngOnInit(): void {
    this.applyWorkspaceContext();
    this.subs.add(this.gtwWorkspace.setTabActive.subscribe(() => {
      this.applyWorkspaceContext();
      this.tryInit();
    }));
    this.subs.add(this.gtwGlobal.globalParamsChanged$.subscribe(() => {
      this.applyWorkspaceContext();
      this.tryInit();
    }));
    this.initViewData();
    this.tryInit();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  private applyWorkspaceContext(): void {
    const activeScreen = this.gtwWorkspace.workspaceFactory?.activeScreen || {};
    const header = buildHeaderDataShell(this.gtwGlobal, this.gtwApp);
    this.baseURLs = generalConfigFromGlobal(this.gtwGlobal);
    this.globalService = header.globalParams || {};
    this.GENERAL_CONFIG = header.generalConfigData || {};
    this.filterParams = normalizeFilterParams(activeScreen);
    this.rowData = rowPayloadFromActiveScreen(activeScreen);
    this.cdr.detectChanges();
  }

  private tryInit(): void {
    if (this.isInitialized) return;
    if (!this.GENERAL_CONFIG || Object.keys(this.GENERAL_CONFIG).length === 0) return;
    if (!this.rowData || Object.keys(this.rowData).length === 0) return;
    this.isInitialized = true;
    this.init();
  }

  private init(): void {
    this.loadData();
  }

  private loadData(): void {
    const params: any = {
      action_id: 438,
      tax_year: this.rowData.TAX_YEAR ?? this.filterParams?.tax_year ?? this.globalService?.tax_year,
      scenario: this.rowData.SCENARIO ?? this.filterParams?.scenario ?? this.globalService?.scenario,
      jcd_key: this.rowData.JCD_KEY ?? this.filterParams?.jcd_key ?? this.globalService?.jcd_key ?? 250,
      combination_key: this.rowData.COMBINATION_KEY ?? this.filterParams?.combination_key
    };

    this.form4797Service.loadFormData(this.GENERAL_CONFIG.base_url, params).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (data: any) => {
        this.formData = data;
        this.processFormData(data);
        this.showFormLoader = false;
        this.cdr.detectChanges();
      },
      (err: any) => {
        console.error('Error loading Form 4797 data:', err);
        this.showFormLoader = false;
        this.cdr.detectChanges();
      }
    );
  }

  /** Process load response into Entry/View bindings (from AngularJS getForm4797Data) */
  processFormData(data: any): void {
    if (!data?.irsForm?.formItemList) return;
    const list = data.irsForm.formItemList;

    this.FormEntryData.section1.singlerows[1] = (this.rowData.TB_AMT != null && this.rowData.TB_AMT !== undefined)
      ? this.rowData.TB_AMT : 0;

    this.FormEntryData.section1.emptyRows = [];
    this.FormEntryData.section2.emptyRows = [];
    this.FormEntryData.section3.emptyRows = [];

    const item2 = list[3];
    const item10 = list[8];
    const item19 = list[14];
    if (item2?.dataRowList?.[0]?.dataCellList) {
      this.line2Headers = (item2.dataRowList[0].dataCellList as any[]).slice(0, 10).map((c: any, i: number) => ({
        name: c.name,
        key: c.key,
        property: { width: c.property?.width || this.defaultWidths[i] }
      }));
      this.Form4797Line2HeaderComment = item2.dataRowList[0].dataCellList[10] || { name: 'Comments' };
    }
    if (item10?.dataRowList?.[0]?.dataCellList) {
      this.line10Headers = (item10.dataRowList[0].dataCellList as any[]).slice(0, 10).map((c: any, i: number) => ({
        name: c.name,
        key: c.key,
        property: { width: c.property?.width || this.defaultWidths[i] }
      }));
      this.Form4797Line10HeaderComment = item10.dataRowList[0].dataCellList[10] || { name: 'Comments' };
    }
    if (item19?.dataRowList?.[0]?.dataCellList) {
      this.line19Headers = (item19.dataRowList[0].dataCellList as any[]).slice(0, 10).map((c: any, i: number) => ({
        name: c.name,
        key: c.key,
        property: { width: c.property?.width || this.defaultWidths[i] }
      }));
      this.Form4797Line19HeaderComment = item19.dataRowList[0].dataCellList[10] || { name: 'Comments' };
    }

    this.form4797Line2Records = [];
    this.form4797Line10Records = [];
    this.form4797Line19Records = [];
    this.displayViewValue_2 = [];
    this.displayEditValue_2 = [];
    this.displayViewValueComment_2 = [];
    this.displayEditValueComment_2 = [];
    this.displayViewValue_10 = [];
    this.displayEditValue_10 = [];
    this.displayViewValueComment_10 = [];
    this.displayEditValueComment_10 = [];
    this.displayViewValue_19 = [];
    this.displayEditValue_19 = [];
    this.displayViewValueComment_19 = [];
    this.displayEditValueComment_19 = [];
    this.formData_2 = { addrows: [], editrows: [], removerows: [] };
    this.formData_10 = { addrows: [], editrows: [], removerows: [] };
    this.formData_19 = { addrows: [], editrows: [], removerows: [] };
    this.totalLine2Amt = 0;
    this.totalLine10Amt = 0;
    this.totalLine19Amt = 0;

    const rd = this.rowData;
    const jcd = rd.JCD_KEY ?? 250;
    const ck = rd.COMBINATION_KEY ?? '';
    const gok = rd.GROUP_OBJ_KEY ?? '';
    const ty = parseInt(rd.TAX_YEAR, 10) || 0;
    const sc = parseInt(rd.SCENARIO, 10) || 0;

    this.buildRecordDataTemplates(ty, sc, jcd, ck, gok);

    const pushRecords = (item: any, lineNo: number, records: any[], formData: any) => {
      if (!item?.dataRowList?.length) return;
      const firstRow = item.dataRowList[0];
      const objId = firstRow?.rowDimensions?.object_id || '';
      const parts = objId.split('~');
      const occur = parts[4];
      const endsWithZero = occur === 0 || occur === '0';
      if (endsWithZero) return;
      records.length = 0;
      formData.editrows = [];
      item.dataRowList.forEach((row: any) => {
        records.push(_.cloneDeep(row));
        if (lineNo === 2) {
          this.displayViewValue_2.push(true);
          this.displayEditValue_2.push(false);
          this.displayViewValueComment_2.push(true);
          this.displayEditValueComment_2.push(false);
        } else if (lineNo === 10) {
          this.displayViewValue_10.push(true);
          this.displayEditValue_10.push(false);
          this.displayViewValueComment_10.push(true);
          this.displayEditValueComment_10.push(false);
        } else if (lineNo === 19) {
          this.displayViewValue_19.push(true);
          this.displayEditValue_19.push(false);
          this.displayViewValueComment_19.push(true);
          this.displayEditValueComment_19.push(false);
        }
        const cells = row.dataCellList;
        if (cells?.[2]?.value && cells[2].value !== 'VARIOUS') cells[2].value = new Date(cells[2].value);
        if (cells?.[3]?.value && cells[3].value !== 'VARIOUS') cells[3].value = new Date(cells[3].value);
        const transDetailKey = row.rowDimensions?.object_id?.split('~')[3];
        const occurence = row.rowDimensions?.object_id?.split('~')[4];
        const editRow = (lineNo === 2 ? this.recordData_2 : lineNo === 10 ? this.recordData_10 : this.recordData_19).map((col: any) => ({
          ..._.cloneDeep(col),
          trans_dtls_key: transDetailKey,
          occurence
        }));
        formData.editrows.push(editRow);
      });
    };

    if (item2?.dataRowList?.length && item2.dataRowList[0].rowDimensions?.object_id?.split('~')[4] !== '0') {
      pushRecords(item2, 2, this.form4797Line2Records, this.formData_2);
      this.totalLine2Amt = this.form4797Line2Records.reduce((sum, r) => sum + (parseInt(r.dataCellList?.[9]?.value, 10) || 0), 0);
    }
    if (item10?.dataRowList?.length && item10.dataRowList[0].rowDimensions?.object_id?.split('~')[4] !== '0') {
      pushRecords(item10, 10, this.form4797Line10Records, this.formData_10);
      this.totalLine10Amt = this.form4797Line10Records.reduce((sum, r) => sum + (parseInt(r.dataCellList?.[9]?.value, 10) || 0), 0);
    }
    if (item19?.dataRowList?.length && item19.dataRowList[0].rowDimensions?.object_id?.split('~')[4] !== '0') {
      pushRecords(item19, 19, this.form4797Line19Records, this.formData_19);
      this.totalLine19Amt = this.form4797Line19Records.reduce((sum, r) => sum + (parseInt(r.dataCellList?.[9]?.value, 10) || 0), 0);
    }

    this.form4797Line2RecordsCopy = _.cloneDeep(this.form4797Line2Records);
    this.form4797Line10RecordsCopy = _.cloneDeep(this.form4797Line10Records);
    this.form4797Line19RecordsCopy = _.cloneDeep(this.form4797Line19Records);

    if (list[4]?.dataRowList?.[0]?.dataCellList) {
      this.line4Details = list[4].dataRowList[0].dataCellList;
      this.line4Amt = parseInt(this.line4Details[2]?.value, 10) || 0;
      this.line4AmtOrig = this.line4Amt;
      this.totalLine2Amt += this.line4Amt;
    }
    if (list[5]?.dataRowList?.[0]?.dataCellList) {
      this.line5Details = list[5].dataRowList[0].dataCellList;
      this.line5Amt = parseInt(this.line5Details[2]?.value, 10) || 0;
      this.line5AmtOrig = this.line5Amt;
      this.totalLine2Amt += this.line5Amt;
    }
    if (list[9]?.dataRowList?.[0]?.dataCellList) {
      this.line14Details = list[9].dataRowList[0].dataCellList;
      this.line14Amt = parseInt(this.line14Details[2]?.value, 10) || 0;
      this.line14AmtOrig = this.line14Amt;
      this.totalLine10Amt += this.line14Amt;
    }
    if (list[10]?.dataRowList?.[0]?.dataCellList) {
      this.line15Details = list[10].dataRowList[0].dataCellList;
      this.line15Amt = parseInt(this.line15Details[2]?.value, 10) || 0;
      this.line15AmtOrig = this.line15Amt;
      this.totalLine10Amt += this.line15Amt;
    }
    if (list[11]?.dataRowList?.[0]?.dataCellList) {
      this.line16Details = list[11].dataRowList[0].dataCellList;
      this.line16Amt = parseInt(this.line16Details[2]?.value, 10) || 0;
      this.line16AmtOrig = this.line16Amt;
      this.totalLine10Amt += this.line16Amt;
    }

    if (list[16]?.dataRowList?.[0]?.dataCellList) this.totalPerTaxReturn = list[16].dataRowList[0].dataCellList;
    if (list[17]?.dataRowList?.[0]?.dataCellList) this.totalPerDetailsLines = list[17].dataRowList[0].dataCellList;
    if (list[19]?.dataRowList?.[0]?.dataCellList) this.totalPerUnallocated = list[19].dataRowList[0].dataCellList;
    if (list[20]?.dataRowList?.[0]?.dataCellList) this.totalPerForm4797 = list[20].dataRowList[0].dataCellList;
    if (list[22]?.dataRowList?.[0]?.dataCellList) this.totalUnallocatedAmt = list[22].dataRowList[0].dataCellList;

    if (this.totalPerForm4797[1] != null) this.totalPerForm4797[1].value = this.totalLine2Amt + this.totalLine10Amt + this.totalLine19Amt;
    if (this.totalUnallocatedAmt[1] != null && this.FormEntryData.section1.singlerows[1] != null) {
      this.totalUnallocatedAmt[1].value = parseInt(String(this.FormEntryData.section1.singlerows[1]), 10) - (this.totalPerForm4797[1]?.value ?? 0);
    }

    if (list[3]?.dataRowList?.[0]?.rowDimensions?.object_id) {
      const l = list[3].dataRowList[0].rowDimensions.object_id.split('~');
      this.line2FormLineKey = parseInt(l[2], 10) || 0;
      this.v_form_key = parseInt(l[5], 10) || 1;
    }
    if (list[8]?.dataRowList?.[0]?.rowDimensions?.object_id) {
      const l = list[8].dataRowList[0].rowDimensions.object_id.split('~');
      this.line10FormLineKey = parseInt(l[2], 10) || 0;
    }
    if (list[14]?.dataRowList?.[0]?.rowDimensions?.object_id) {
      const l = list[14].dataRowList[0].rowDimensions.object_id.split('~');
      this.line19FormLineKey = parseInt(l[2], 10) || 0;
    }

    this.initViewData();
  }

  private buildRecordDataTemplates(taxYear: number, scenario: number, jcd_key: number, combinationKey: any, groupObjKey: any): void {
    const base = (lineNo: number, attribs: { name: string; key: number }[]) =>
      attribs.map(a => ({
        tax_year: taxYear,
        trans_type_key: 7,
        combination_key: combinationKey,
        group_obj_key: groupObjKey,
        form_key: 1,
        line_no: lineNo,
        occurence: null,
        line_attrib_key: a.key,
        Attribute_Name: a.name,
        Attribute_Value: a.name.includes('DATE') ? new Date() : (a.name === 'WORTHLESS_FLAG' || a.name === 'IS_SEC_754' ? 'N' : 0),
        trans_dtls_key: null,
        trans_status: 'A',
        is_dirty: 'N'
      }));
    this.recordData_2 = base(2, [
      { name: 'PROPERTY_DESC', key: 1 }, { name: 'DATE_ACQ', key: 2 }, { name: 'DATE_SOLD', key: 3 },
      { name: 'SALE_PRICE', key: 4 }, { name: 'DEPRECIATION_ALLOWED', key: 5 }, { name: 'COST_BASIS', key: 6 },
      { name: 'WORTHLESS_FLAG', key: 7 }, { name: 'IS_SEC_754', key: 8 }, { name: 'GAIN_LOSS', key: 9 }, { name: 'COMMENTS', key: 497 }
    ]);
    this.recordData_10 = base(10, [
      { name: 'PROPERTY_DESC', key: 10 }, { name: 'DATE_ACQ', key: 11 }, { name: 'DATE_SOLD', key: 12 },
      { name: 'SALE_PRICE', key: 13 }, { name: 'DEPRECIATION_ALLOWED', key: 14 }, { name: 'COST_BASIS', key: 15 },
      { name: 'WORTHLESS_FLAG', key: 16 }, { name: 'IS_SEC_754', key: 17 }, { name: 'GAIN_LOSS', key: 18 }, { name: 'COMMENTS', key: 498 }
    ]);
    this.recordData_19 = base(19, [
      { name: 'PROPERTY_DESC', key: 22 }, { name: 'DATE_ACQ', key: 23 }, { name: 'DATE_SOLD', key: 24 },
      { name: 'SALE_PRICE', key: 25 }, { name: 'DEPRECIATION_ALLOWED', key: 26 }, { name: 'COST_BASIS', key: 27 },
      { name: 'WORTHLESS_FLAG', key: 28 }, { name: 'IS_SEC_754', key: 29 }, { name: 'GAIN_LOSS', key: 30 }, { name: 'COMMENTS', key: 499 }
    ]);
  }

  private initViewData(): void {
    this.viewData = {
      partI: {
        title: 'Part I: Sales or Exchanges of property Used in a Trade or Business and Involuntary Conversions From Other Than Casuality or Theft Property Held More Than 1 Year',
        cols: ['4797 Line', 'Description of Property', 'Date Acquired', 'Date Sold', 'Gross Sales Price', 'Depreciation allowed', 'Cost or Other Basis', 'Gain or (Loss)', 'Worthless Stock?', 'Section 754?'],
        rows: [{}, {}],
        rows2: [
          { num: 3, description: 'Gain, if any, from Form 4684, line 39' },
          { num: 4, description: 'Section 1231 gain from installment sales from Form 6252, line 26 or 37' },
          { num: 5, description: 'Section 1231 gain or (loss) from like-kind exchanges from Form 8824' },
          { num: 6, description: 'Gain, if any, from line 32, from other than casualty or theft' },
          { num: 7, description: 'Combine lines 2 through 6. Enter the gain or (loss) here and on the appropriate line as follows:' },
          { description: 'Partnerships (except electing large partnerships) and S corporations...' },
          { description: 'Individuals, partners, S corporation shareholders...' },
          { num: 8, description: 'Non recaptured net section 1231 losses from prior years.' },
          { num: 9, description: 'Subtract line 8 from line 7...' }
        ],
        totals: [{ description: 'Total Part I Gain or (Loss)' }]
      },
      partII: {
        title: 'Part II: Ordinary Gains and Losses',
        cols: ['4797 Line', 'Description of Property', 'Date Acquired', 'Date Sold', 'Gross Sales Price', 'Depreciation allowed', 'Cost or Other Basis', 'Gain or (Loss)', 'Worthless Stock?', 'Section 754?'],
        rows: [{}, {}],
        rows2: [
          { num: 11, description: 'Loss, if any, from line 7' },
          { num: 12, description: 'Gain, if any, from line 7 or amount from line 8, if applicable' },
          { num: 13, description: 'Gain, if any, from line 31' },
          { num: 14, description: 'Net gain or (loss) from Form 4684, lines 31 and 38a' },
          { num: 15, description: 'Ordinary gain from installment sales from Form 6252, line 25 or 36' },
          { num: 16, description: 'Ordinary gain or (loss) from like-kind exchanges from Form 8824' },
          { num: 17, description: 'Combine lines 10 through 16' },
          { num: 18, description: 'For all except individual returns...' },
          { description: 'a. If the loss on line 11 includes...' },
          { description: 'b. Redetermine the gain or (loss)...' }
        ],
        totals: [{ description: 'Total Part II Gain or (Loss)' }]
      },
      partIII: {
        title: 'Part III: Gain From Disposition of Property Under Section 1245',
        cols: ['4797 Line', 'Description of Property', 'Date Acquired', 'Date Sold', 'Gross Sales Price', 'Depreciation allowed', 'Cost or Other Basis', 'Gain or (Loss)', 'Worthless Stock?', 'Section 754?'],
        rows: [{}, {}],
        rows2: [
          { num: '', description: 'These columns relate to the properties on lines 19A through 19D', propertyA: 'Property A', propertyB: 'Property B', propertyC: 'Property C', propertyD: 'Property D' },
          { num: 20, description: 'Gross sales price (Note: See line 1 before completing.)' },
          { num: 21, description: 'Cost or other basis plus expense of sale' },
          { num: 22, description: 'Depreciation (or depletion) allowed or allowable' },
          { num: 23, description: 'Adjusted basis. Subtract line 22 from line 21' },
          { num: 24, description: 'Total gain. Subtract line 23 from line 20' },
          { num: 25, description: 'If section 1245 property:' },
          { num: '', description: 'a. Depreciation allowed or allowable from line 22' },
          { num: '', description: 'b. Enter the smaller of line 24 or 25a' },
          { num: 26, description: 'Section 1245 gain...' }
        ],
        totals: [{ description: 'Total Part III' }],
        rows3: [] as any[],
        rows4: [] as any[]
      },
      partIV: {
        title: 'Part IV: Summary',
        cols: ['Description', 'Gain or Loss'],
        rows: [
          { num: 1, description: 'Total Worthless Stock Deduction - Ordinary per Tax Return' },
          { num: 2, description: 'Total Worthless Stock Deduction - Ordinary per Detail Lines' },
          { num: 3, description: 'Total Worthless Stock Deduction - Ordinary Unallocated' },
          { num: 4, description: 'Total Gain or (Loss) as per Form 4797' },
          { num: 5, description: 'Unallocated Amount' }
        ]
      }
    };
  }

  addSection(lineNo: number): void {
    if (lineNo === 2) {
      this.FormEntryData.section1.emptyRows.push({});
      this.formData_2.addrows.push(_.cloneDeep(this.recordData_2));
    } else if (lineNo === 10) {
      this.FormEntryData.section2.emptyRows.push({});
      this.formData_10.addrows.push(_.cloneDeep(this.recordData_10));
    } else if (lineNo === 19) {
      this.FormEntryData.section3.emptyRows.push({});
      this.formData_19.addrows.push(_.cloneDeep(this.recordData_19));
    }
    this.cdr.detectChanges();
  }

  sectionRemove(line: number, index: number): void {
    if (line === 2) {
      this.FormEntryData.section1.emptyRows.splice(index, 1);
      const adjustAmount = this.formData_2.addrows[index]?.[8]?.Attribute_Value ?? 0;
      this.totalLine2Amt -= adjustAmount;
      if (this.totalPerForm4797[1]) this.totalPerForm4797[1].value = (this.totalPerForm4797[1].value ?? 0) - adjustAmount;
      if (this.totalUnallocatedAmt[1]) this.totalUnallocatedAmt[1].value = (this.totalUnallocatedAmt[1].value ?? 0) + adjustAmount;
      this.formData_2.addrows.splice(index, 1);
    } else if (line === 10) {
      this.FormEntryData.section2.emptyRows.splice(index, 1);
      const adjustAmount = this.formData_10.addrows[index]?.[8]?.Attribute_Value ?? 0;
      this.totalLine10Amt -= adjustAmount;
      if (this.totalPerForm4797[1]) this.totalPerForm4797[1].value = (this.totalPerForm4797[1].value ?? 0) - adjustAmount;
      if (this.totalUnallocatedAmt[1]) this.totalUnallocatedAmt[1].value = (this.totalUnallocatedAmt[1].value ?? 0) + adjustAmount;
      this.formData_10.addrows.splice(index, 1);
    } else if (line === 19) {
      this.FormEntryData.section3.emptyRows.splice(index, 1);
      const adjustAmount = this.formData_19.addrows[index]?.[8]?.Attribute_Value ?? 0;
      this.totalLine19Amt -= adjustAmount;
      if (this.totalPerForm4797[1]) this.totalPerForm4797[1].value = (this.totalPerForm4797[1].value ?? 0) - adjustAmount;
      if (this.totalUnallocatedAmt[1]) this.totalUnallocatedAmt[1].value = (this.totalUnallocatedAmt[1].value ?? 0) + adjustAmount;
      this.formData_19.addrows.splice(index, 1);
    }
    this.recalcTotals();
    this.cdr.detectChanges();
  }

  errorChange(line: number, rowNum: number, colNum: number): void {
    if (line === 2) {
      if (!this.formData_2_errorMessages.addrows[rowNum]) this.formData_2_errorMessages.addrows[rowNum] = [];
      this.formData_2_errorMessages.addrows[rowNum][colNum] = { column_error: null };
    }
    if (line === 10) {
      if (!this.formData_10_errorMessages.addrows[rowNum]) this.formData_10_errorMessages.addrows[rowNum] = [];
      this.formData_10_errorMessages.addrows[rowNum][colNum] = { column_error: null };
    }
    if (line === 19) {
      if (!this.formData_19_errorMessages.addrows[rowNum]) this.formData_19_errorMessages.addrows[rowNum] = [];
      this.formData_19_errorMessages.addrows[rowNum][colNum] = { column_error: null };
    }
    this.cdr.detectChanges();
  }

  setGainLoss(line: number, isExisting: boolean, index: number): void {
    let salePrice: number, dep: number, cost: number, gainLoss: number;
    if (line === 2 && !isExisting && this.formData_2.addrows[index]) {
      salePrice = parseInt(this.formData_2.addrows[index][3]?.Attribute_Value, 10) || 0;
      dep = parseInt(this.formData_2.addrows[index][4]?.Attribute_Value, 10) || 0;
      cost = parseInt(this.formData_2.addrows[index][5]?.Attribute_Value, 10) || 0;
      gainLoss = salePrice + dep - cost;
      this.formData_2.addrows[index][8].Attribute_Value = gainLoss;
    } else if (line === 2 && isExisting && this.form4797Line2Records[index]?.dataCellList) {
      salePrice = parseInt(this.form4797Line2Records[index].dataCellList[4]?.value, 10) || 0;
      dep = parseInt(this.form4797Line2Records[index].dataCellList[5]?.value, 10) || 0;
      cost = parseInt(this.form4797Line2Records[index].dataCellList[6]?.value, 10) || 0;
      gainLoss = salePrice + dep - cost;
      this.form4797Line2Records[index].dataCellList[9].value = gainLoss;
      this.totalLine2Amt = this.form4797Line2Records.reduce((s, r) => s + (parseInt(r.dataCellList?.[9]?.value, 10) || 0), 0);
      this.totalLine2Amt += this.line4Amt + this.line5Amt;
    }
    if (line === 10 && !isExisting && this.formData_10.addrows[index]) {
      salePrice = parseInt(this.formData_10.addrows[index][3]?.Attribute_Value, 10) || 0;
      dep = parseInt(this.formData_10.addrows[index][4]?.Attribute_Value, 10) || 0;
      cost = parseInt(this.formData_10.addrows[index][5]?.Attribute_Value, 10) || 0;
      gainLoss = salePrice + dep - cost;
      this.formData_10.addrows[index][8].Attribute_Value = gainLoss;
    } else if (line === 10 && isExisting && this.form4797Line10Records[index]?.dataCellList) {
      salePrice = parseInt(this.form4797Line10Records[index].dataCellList[4]?.value, 10) || 0;
      dep = parseInt(this.form4797Line10Records[index].dataCellList[5]?.value, 10) || 0;
      cost = parseInt(this.form4797Line10Records[index].dataCellList[6]?.value, 10) || 0;
      gainLoss = salePrice + dep - cost;
      this.form4797Line10Records[index].dataCellList[9].value = gainLoss;
      this.totalLine10Amt = this.form4797Line10Records.reduce((s, r) => s + (parseInt(r.dataCellList?.[9]?.value, 10) || 0), 0);
      this.totalLine10Amt += this.line14Amt + this.line15Amt + this.line16Amt;
    }
    if (line === 19 && !isExisting && this.formData_19.addrows[index]) {
      salePrice = parseInt(this.formData_19.addrows[index][3]?.Attribute_Value, 10) || 0;
      dep = parseInt(this.formData_19.addrows[index][4]?.Attribute_Value, 10) || 0;
      cost = parseInt(this.formData_19.addrows[index][5]?.Attribute_Value, 10) || 0;
      gainLoss = salePrice + dep - cost;
      this.formData_19.addrows[index][8].Attribute_Value = gainLoss;
    } else if (line === 19 && isExisting && this.form4797Line19Records[index]?.dataCellList) {
      salePrice = parseInt(this.form4797Line19Records[index].dataCellList[4]?.value, 10) || 0;
      dep = parseInt(this.form4797Line19Records[index].dataCellList[5]?.value, 10) || 0;
      cost = parseInt(this.form4797Line19Records[index].dataCellList[6]?.value, 10) || 0;
      gainLoss = salePrice + dep - cost;
      this.form4797Line19Records[index].dataCellList[9].value = gainLoss;
      this.totalLine19Amt = this.form4797Line19Records.reduce((s, r) => s + (parseInt(r.dataCellList?.[9]?.value, 10) || 0), 0);
    }
    this.recalcTotals();
    this.cdr.detectChanges();
  }

  editExistingRecord(line: number, index: number): void {
    if (line === 2) {
      this.displayViewValue_2[index] = !this.displayViewValue_2[index];
      this.displayEditValue_2[index] = !this.displayEditValue_2[index];
      this.displayViewValueComment_2[index] = !this.displayViewValueComment_2[index];
      this.displayEditValueComment_2[index] = !this.displayEditValueComment_2[index];
    } else if (line === 10) {
      this.displayViewValue_10[index] = !this.displayViewValue_10[index];
      this.displayEditValue_10[index] = !this.displayEditValue_10[index];
      this.displayViewValueComment_10[index] = !this.displayViewValueComment_10[index];
      this.displayEditValueComment_10[index] = !this.displayEditValueComment_10[index];
    } else if (line === 19) {
      this.displayViewValue_19[index] = !this.displayViewValue_19[index];
      this.displayEditValue_19[index] = !this.displayEditValue_19[index];
      this.displayViewValueComment_19[index] = !this.displayViewValueComment_19[index];
      this.displayEditValueComment_19[index] = !this.displayEditValueComment_19[index];
    }
    this.cdr.detectChanges();
  }

  removeExistingRecord(line: number, index: number, objectId: string): void {
    this.gtwSnackbarService.openSnackBar('Please click on \'Save and Proceed\' to Delete this Transaction. Otherwise click on \'Cancel\'.', 'gtw-snackbar--yellow');
  }

  propChange(line: number, colNum: number, index: number): void {
    this.cdr.detectChanges();
  }

  adjustGainLoss(lineNo: number): void {
    if (lineNo === 4 || lineNo === 5) {
      this.totalLine2Amt += (this.line4Amt - this.line4AmtOrig) + (this.line5Amt - this.line5AmtOrig);
      if (this.totalPerForm4797[1]) this.totalPerForm4797[1].value = (this.totalPerForm4797[1].value ?? 0) + (this.line4Amt - this.line4AmtOrig) + (this.line5Amt - this.line5AmtOrig);
      this.line4AmtOrig = this.line4Amt;
      this.line5AmtOrig = this.line5Amt;
    }
    if (lineNo === 14 || lineNo === 15 || lineNo === 16) {
      this.totalLine10Amt += (this.line14Amt - this.line14AmtOrig) + (this.line15Amt - this.line15AmtOrig) + (this.line16Amt - this.line16AmtOrig);
      if (this.totalPerForm4797[1]) this.totalPerForm4797[1].value = (this.totalPerForm4797[1].value ?? 0) + (this.line14Amt - this.line14AmtOrig) + (this.line15Amt - this.line15AmtOrig) + (this.line16Amt - this.line16AmtOrig);
      this.line14AmtOrig = this.line14Amt;
      this.line15AmtOrig = this.line15Amt;
      this.line16AmtOrig = this.line16Amt;
    }
    this.recalcTotals();
    this.cdr.detectChanges();
  }

  lineItemChange(lineNo: number): void {
    this.cdr.detectChanges();
  }

  private recalcTotals(): void {
    if (this.totalPerForm4797[1] != null) this.totalPerForm4797[1].value = this.totalLine2Amt + this.totalLine10Amt + this.totalLine19Amt;
    if (this.totalUnallocatedAmt[1] != null && this.FormEntryData.section1.singlerows[1] != null) {
      this.totalUnallocatedAmt[1].value = parseInt(String(this.FormEntryData.section1.singlerows[1]), 10) - (this.totalPerForm4797[1]?.value ?? 0);
    }
  }

  convertDate(dateObject: Date | string | null): string | null {
    if (!dateObject) return null;
    const d = dateObject instanceof Date ? dateObject : new Date(dateObject);
    if (isNaN(d.getTime())) return null;
    const month = (d.getMonth() + 1) < 10 ? '0' + (d.getMonth() + 1) : (d.getMonth() + 1);
    const date = d.getDate() < 10 ? '0' + d.getDate() : d.getDate();
    return month + '/' + date + '/' + d.getFullYear();
  }

  private buildSaveGlobalService(): any {
    const gs = { ...(this.globalService || {}) };
    const fp = this.filterParams || {};
    const rd = this.rowData || {};
    if (!gs.scenarioCode) gs.scenarioCode = fp.scenarioCode || fp.scenario_code || 'RAF';
    if (!gs.is_issue_key_enabled) gs.is_issue_key_enabled = fp.is_issue_key_enabled || 'N';
    if (!gs.checkLockedbj) {
      const scenario = fp.scenario ?? gs.scenario ?? rd.SCENARIO;
      const checkLocked = [{
        leid: rd.LEID || rd.SOURCE_LEID || '',
        cdr_number: rd.CDR_NO || rd.MARS || rd.TAX_CODE || '',
        consol_group_key: String(rd.CONSOL_GROUP_KEY ?? ''),
        reporting_period: String(rd.REPORTING_PERIOD ?? ''),
        combination_key: String(rd.COMBINATION_KEY ?? ''),
        scenario_key: parseInt(String(scenario), 10) || 0
      }];
      gs.checkLockedbj = JSON.stringify(checkLocked);
    }
    return gs;
  }

  save(): void {
    if (this.crudLoading) return;
    const formData = {
      addrows: [] as any[],
      editrows: [] as any[],
      removerows: [] as any[]
    };
    [...this.formData_2.addrows, ...this.formData_10.addrows, ...this.formData_19.addrows].forEach(row => {
      const singleRow = row.map((col: any) => {
        const c = { ...col };
        if ((col.Attribute_Name === 'DATE_ACQ' || col.Attribute_Name === 'DATE_SOLD') && col.Attribute_Value && col.Attribute_Value !== 'VARIOUS') {
          c.Attribute_Value = this.convertDate(col.Attribute_Value);
        }
        return c;
      });
      formData.addrows.push(singleRow);
    });
    [...this.formData_2.editrows, ...this.formData_10.editrows, ...this.formData_19.editrows].forEach(row => {
      formData.editrows.push(row.map((col: any) => {
        const c = { ...col };
        if ([3, 4, 5, 8].some(i => row[i] === col) && typeof c.Attribute_Value !== 'number') {
          c.Attribute_Value = parseInt(c.Attribute_Value, 10);
        }
        return c;
      }));
    });
    formData.removerows = [...this.formData_2.removerows, ...this.formData_10.removerows, ...this.formData_19.removerows];
    formData.addrows.forEach((item: any) => item.forEach((child: any) => child.form_key = this.v_form_key));
    formData.editrows.forEach((item: any) => item.forEach((child: any) => child.form_key = this.v_form_key));
    formData.removerows.forEach((item: any) => item.form_key = this.v_form_key);

    const mainData = [formData];
    const baseUrl = this.GENERAL_CONFIG?.base_url || '';
    const jsonSettings = [{
      tax_year: this.rowData.TAX_YEAR ?? this.filterParams?.tax_year ?? this.globalService?.tax_year,
      scenario: this.rowData.SCENARIO ?? this.filterParams?.scenario ?? this.globalService?.scenario,
      jcd_key: this.rowData.JCD_KEY ?? this.filterParams?.jcd_key ?? this.globalService?.jcd_key ?? 250
    }];
    const enrichedGS = this.buildSaveGlobalService();

    if (formData.addrows.length === 0 && formData.editrows.length === 0 && formData.removerows.length === 0) {
      this.gtwSnackbarService.openSnackBar('No changes to save.', 'gtw-snackbar--yellow');
      this.requestGridUpdate.emit('cancel');
      this.cdr.detectChanges();
      return;
    }

    this.crudLoading = true;
    this.cdr.detectChanges();
    this.form4797Service.saveFormData(baseUrl, mainData, jsonSettings, enrichedGS, this.filterParams, 'Form 4797 Save').pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (res: any) => {
        this.crudLoading = false;
        if (res?.jsonObject && Array.isArray(res.jsonObject) && res.jsonObject.length > 0) {
          this.gtwSnackbarService.openSnackBar(res.errorMessage || 'Please correct the errors below', 'gtw-snackbar--red');
          this.formData_2_errorMessages = res.jsonObject[0] || this.formData_2_errorMessages;
          this.formData_10_errorMessages = res.jsonObject[1] || this.formData_10_errorMessages;
          this.formData_19_errorMessages = res.jsonObject[2] || this.formData_19_errorMessages;
        } else if (res?.callSuccess === '1' && (res?.errorMessage == null || res?.errorMessage === 'null')) {
          this.gtwSnackbarService.openSnackBar('Transactions saved successfully', 'gtw-snackbar--green');
          this.requestGridUpdate.emit('refresh');
        } else {
          this.gtwSnackbarService.openSnackBar(res?.errorMessage || 'Error occurred in saving the Transaction.', 'gtw-snackbar--red');
        }
        this.cdr.detectChanges();
      },
      (err: any) => {
        this.crudLoading = false;
        this.gtwSnackbarService.openSnackBar('Error occurred in saving the Transaction. If this continues please contact support.', 'gtw-snackbar--red');
        this.cdr.detectChanges();
      }
    );
  }

  reset(): void {
    this.loadData();
  }

  cancel(): void {
    this.requestGridUpdate.emit('cancel');
  }

  onTabChange(index: number): void {
    this.activeTab = index;
    this.selectedTabName = index === 0 ? 'Form Entry' : 'Form View';
    this.cdr.detectChanges();
  }
}
